import { ChevronDownIcon as ChevronDown } from '@heroicons/react/20/solid';
import { Avatar } from 'components/AvatarCard/Avatar';
import { Menu } from 'components/Menu';
import React from 'react';
import tw from 'twin.macro';
import { UserAccount } from 'types/user';

interface Props {
  userAccount: UserAccount;
  large?: boolean;
}

export function AvatarButton({ userAccount, large }: Props) {
  const isDefaultAvatar =
    !userAccount.picture || userAccount.picture === 'user';

  const userInitials = `${userAccount.givenName?.[0] || ''}${
    userAccount.familyName?.[0] || ''
  }`.toUpperCase();
  return (
    <div tw="ml-4 flex items-center">
      <Menu.Button tw="p-1!" aria-label="profile" minimal>
        <Avatar
          css={[tw`mr-1 rounded-full`, isDefaultAvatar && tw`bg-[#FFC3A5]`]}
          fill={!isDefaultAvatar}
          dimensions={
            large
              ? {
                  height: 34,
                  width: 34,
                }
              : {
                  height: 30,
                  width: 30,
                }
          }
          picture={userAccount.picture}
          userInitials={userInitials}
        />
        <ChevronDown tw="h-5 w-5" />
      </Menu.Button>
    </div>
  );
}
